import * as React from "react";
import { action, autorun, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { UitkFavoriteSwitch } from "uitk-react-switch";
import { Level, liveAnnounce } from "uitk-react-utils";
import { withLocalization } from "@shared-ui/localization-context";
import { HeartButtonProps } from "./typings";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

const TrackedFavoriteSwitch = FlexClickTracker(UitkFavoriteSwitch);
enum RfrrId {
  SAVE = "save",
  UNSAVE = "unsave",
}

export enum EntityType {
  HOTEL = "hotel",
  THING_TO_DO = "local-expert",
  POINT_OF_INTEREST = "poi-gaia",
  CITY = "destination",
  NEIGHBORHOOD = "neighborhood",
}

@withLocalization
@inject("shortlist", "uiPage")
@observer
export class HeartButton extends React.Component<HeartButtonProps> {
  @observable
  private isSaved = false;

  public constructor(props: HeartButtonProps) {
    super(props);

    // This listens to the ShortlistStore for changes
    autorun(() => {
      if (
        this.props.shortlist &&
        this.props.shortlist.savedFavorites &&
        this.props.shortlist.savedFavorites.length > 0 &&
        this.props.heartableEntity.id
      ) {
        this.isSaved =
          this.props.shortlist.savedFavorites.filter((id) => id === this.props.heartableEntity.id).length > 0;
      }
    });
  }

  @action
  private handleClick = () => {
    const { formatText } = this.props.l10n;
    this.isSaved = !this.isSaved;
    if (
      !(
        this.props.heartableEntity.id &&
        this.props.heartableEntity.name &&
        this.props.heartableEntity.entityType &&
        this.props.shortlist &&
        this.props.uiPage
      )
    ) {
      return;
    }

    if (!this.isSaved) {
      this.props.shortlist.unsaveFavorite(this.props.heartableEntity);
      liveAnnounce(
        formatText("hotels.shortlist.removeFromList.notification", this.props.heartableEntity.name),
        Level.POLITE
      );

      return;
    }
    const notificationText = formatText("hotels.shortlist.saveToList.notification", this.props.heartableEntity.name);
    liveAnnounce(notificationText, Level.POLITE);
    this.props.shortlist.saveFavorite(this.props.heartableEntity);
    this.props.uiPage.showNotification(notificationText, "favorite");
  };

  public render() {
    const { moduleName, heartableEntity } = this.props;
    const keyHelper = new ItemKeyHelper("HeartButton");
    const { formatText } = this.props.l10n;

    if (!heartableEntity.id || !moduleName) {
      return null;
    }

    const saveOrUnsaveLabel = this.isSaved
      ? formatText("hotels.shortlist.removeFromList.a11yLabel", heartableEntity.name)
      : formatText("hotels.shortlist.saveToList.a11yLabel", heartableEntity.name);

    return (
      <TrackedFavoriteSwitch
        id={`shortlist-item-${heartableEntity.id}-${keyHelper.next()}`}
        moduleName={moduleName}
        checked={this.isSaved}
        onChange={this.handleClick}
        rfrr={`shortlist.${this.isSaved ? RfrrId.UNSAVE : RfrrId.SAVE}`}
        label={saveOrUnsaveLabel}
      />
    );
  }
}
